import { Autocomplete, TextField } from "@mui/material"

export function ConditionValueComplianceType({ value, onChange }) {
    const selected = Array.isArray(value) ? value : value ? [value] : []

    return (
        <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={selected}
            onChange={handleChange}
            renderInput={(params) => <TextField {...params} placeholder="Type compliance types and press Enter..." />}
        />
    )

    function handleChange(_, newValue) {
        onChange(newValue)
    }
}
